import clsx from 'clsx/lite'
import React from 'react'

type SphereGradientProps = {
  className: string
}

export const BlueGradient: React.FC<SphereGradientProps> = ({ className }) => (
  <div
    className={clsx(
      className,
      'absolute h-[860px] w-[860px] -rotate-45 overflow-hidden rounded-full blur-[81px]',
      'bg-[linear-gradient(218deg,_#EAF5FF_100%,_#FFFFFF_0%)]'
    )}
  />
)

export const GreenGradient: React.FC<SphereGradientProps> = ({ className }) => (
  <div
    className={clsx(
      className,
      'absolute h-[860px] w-[860px] -rotate-[120deg] overflow-hidden rounded-full blur-[81px]',
      'bg-[linear-gradient(231deg,_#EBFAD8_100%,_rgba(255,_255,_255,_0.00)_89%)]'
    )}
  />
)

export const Gradient = () => (
  <div
    className={clsx(
      'invisible absolute bottom-0 left-1/2 -z-10 -translate-x-1/2 transform overflow-hidden'
    )}
  >
    <div className="relative left-1/2 h-[860px] w-[1720px] -translate-x-1/2 transform">
      <BlueGradient className="-bottom-[50%] left-[10%]" />
      <GreenGradient className="-bottom-[50%] right-[5%]" />
    </div>
  </div>
)

export const GradientPlayerYoutubeModal = () => (
  <div
    className={clsx('absolute left-1/2 top-0 -z-10 -translate-x-1/2 transform')}
  >
    <div className="max-w-screen relative left-1/2 h-[860px] w-[1720px] -translate-x-1/2 transform">
      <BlueGradient className="-top-[90%] left-[10%]" />
      <GreenGradient className="-top-[90%] right-[5%]" />
    </div>
  </div>
)

export const GradientPerFiscalite = () => (
  <div className="absolute bottom-0 left-0 right-0 top-0 z-[-1]">
    <GreenGradient className="-right-[200%] top-[25%]" />
    <BlueGradient className="right-[10%] top-[75%]" />
  </div>
)
